import React, {useState, useEffect, useRef} from 'react';
import {useHistory, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {ProgressBar} from 'primereact/progressbar';
import {Form, Field} from 'react-final-form';
import {Button} from "primereact/button";
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {InputText} from "primereact/inputtext";
import {classNames} from "primereact/utils";
import {Panel} from "primereact/panel";
import {addLocale} from "primereact/api";
import axios from "axios";

const RolesFormComponent = (props) => {

  const {t} = props;
  const history = useHistory();
  const {entity, id} = useParams();
  const [loading, setLoading] = useState(false);
  const [allRoles, setAllRoles] = useState([]);
  const [availableRoles, setAvailableRoles] = useState([]);
  const [initLoading, setInitLoading] = useState(true);
  const [selectedRoles, setSelectedRoles] = useState([]);
  const [selectedAvailableRows, setSelectedAvailableRows] = useState([]);
  const [selectedSelectedRows, setSelectedSelectedRows] = useState([]);
  const dtLeft = useRef(null);
  const dtRight = useRef(null);
  const [formData, setFormData] = useState({});
  const [availableRoleSearch, setAvailableRoleSearch] = useState('');
  const [selectedRoleSearch, setSelectedRoleSearch] = useState('');

  const validate = (data) => {
    let errors = {};
    // if (!data.company) {
    //   errors.company = 'Kötelező mező';
    // }
    // if (!data.partner) {
    //   errors.partner = 'Kötelező mező';
    // }
    return errors;
  };
  const onSubmit = (data) => {
    setLoading(true)
    const payload = {
      name: (data?.name ?? '').trim(),
      roles: (selectedRoles || []).map(r => r.code),
    };
    if ((window.App.urlVars().roleId) || (entity === 'roles' && id)) {
      apiCall('patch', '/api/v2/role-group/' + (window.App.urlVars().roleId ?? id), payload)
        .then(response => {
          window.App.toastShow('success', t('toastSaveSuccess'));
          window.App.setState({rerenderRolesList: Math.random()})
          if (props.goback === true) {
            history.push(props.backlink);
          }
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    } else {
      apiCall('post', '/api/v2/role-group', data)
        .then(response => {
          window.App.toastShow('success', t('toastSaveSuccess'));
          window.App.setState({rerenderRolesList: Math.random()})
          if (props.goback === true) {
            history.push(props.backlink);
          } else {
            history.push('/settings/roles/update/' + response.data.data.id);
          }
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }
  };

  const isFormFieldValid = (meta) => !!(meta.touched && meta.error);
  const getFormErrorMessage = (meta) => {
    return isFormFieldValid(meta) && <small className="p-error">{meta.error}</small>;
  };

  addLocale('hu', {
    firstDayOfWeek: 1,
    dayNames: ['vasárnap', 'hétfő', 'kedd', 'szerda', 'csütörtök', 'péntek', 'szombat'],
    dayNamesShort: ['vas', 'hé', 'ke', 'sze', 'csü', 'pé', 'szo'],
    dayNamesMin: ['V', 'H', 'K', 'SZ', 'CS', 'P', 'SZ'],
    monthNames: ['január', 'február', 'március', 'április', 'május', 'június', 'július', 'augusztus', 'szeptember',
      'október', 'november', 'december'],
    monthNamesShort: ['jan', 'feb', 'mar', 'ápr', 'máj', 'jun', 'júl', 'aug', 'szep', 'okt', 'nov', 'dec'],
    today: 'Ma',
    clear: 'Töröl'
  });

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
  }

  const sortRolesByName = (roles = []) => {
    return [...roles].sort((a, b) =>
      (a?.name || a?.code || '').localeCompare(
        b?.name || b?.code || '',
        'hu',
        { sensitivity: 'base' }
      )
    );
  };

  const filterRoles = (roles = [], search = '') => {
    const q = (search || '').toLowerCase().trim();
    if (!q) {
      return roles;
    }
    return roles.filter(role =>
      (role?.name || '').toLowerCase().includes(q) ||
      (role?.code || '').toLowerCase().includes(q)
    );
  };

  const handleDragStart = (event, item, source) => {
    let dragged = [item];
    if (source === 'available' && selectedAvailableRows?.length) {
      const isInSel = selectedAvailableRows.some(x => x.code === item.code);
      if (isInSel) dragged = selectedAvailableRows;
    }
    if (source === 'selected' && selectedSelectedRows?.length) {
      const isInSel = selectedSelectedRows.some(x => x.code === item.code);
      if (isInSel) dragged = selectedSelectedRows;
    }
    event.dataTransfer.setData(
      "application/json",
      JSON.stringify({
        source,
        codes: dragged.map(r => r.code),
      })
    );
  };

  const handleDragOver = (event) => {
    event.preventDefault();
  };

  const handleDrop = (event, target) => {
    event.preventDefault();
    let raw =
      event.dataTransfer.getData("application/json") ||
      event.dataTransfer.getData("text/plain");
    if (!raw) return;
    let payload;
    try { payload = JSON.parse(raw); } catch (e) { return; }
    const codes = Array.isArray(payload?.codes) ? payload.codes : [];
    if (!codes.length) return;
    if (target === 'selected') {
      const toAdd = availableRoles.filter(r => codes.includes(r.code));
      if (!toAdd.length) return;
      setSelectedRoles(prev => {
        const map = new Map((prev || []).map(x => [x.code, x]));
        toAdd.forEach(x => map.set(x.code, x));
        return sortRolesByName(Array.from(map.values()));
      });
      setAvailableRoles(prev => (prev || []).filter(r => !codes.includes(r.code)));
      setSelectedAvailableRows([]);
    }
    if (target === 'available') {
      const toMoveBack = selectedRoles.filter(r => codes.includes(r.code));
      if (!toMoveBack.length) return;
      setAvailableRoles(prev => {
        const map = new Map((prev || []).map(x => [x.code, x]));
        toMoveBack.forEach(x => map.set(x.code, x));
        return sortRolesByName(Array.from(map.values()));
      });
      setSelectedRoles(prev => (prev || []).filter(r => !codes.includes(r.code)));
      setSelectedSelectedRows([]);
    }
  };

  useEffect(() => {
    let mounted = true;
    setInitLoading(true);
    const shouldLoadGroup = ((window.App.urlVars().roleId) || (entity === 'roles' && id));
    const groupId = (window.App.urlVars().roleId ?? id);
    const pRoles = apiCall('get', '/api/v2/dictionary/role')
    .then(response => {
      const data = response.data?.data ?? [];
      if (Array.isArray(data) && typeof data[0] === 'string') {
        return data.map(code => ({ code, name: code }));
      }
      if (Array.isArray(data) && data[0]?.code) {
        return data.map(r => ({ code: r.code, name: r.name ?? r.code }));
      }
      return [];
    });
    const pGroup = shouldLoadGroup
      ? apiCall('get', '/api/v2/role-group/' + groupId).then(response => (response.data?.data || {}))
      : Promise.resolve({});
    Promise.all([pRoles, pGroup])
      .then(([all, dto]) => {
        if (!mounted) return;
        setAllRoles(sortRolesByName(all));
        setFormData(dto || {});
        const roles = dto?.roles || [];
        const roleCodes = Array.isArray(roles)
          ? roles.map(r => (typeof r === "string" ? r : r?.code)).filter(Boolean)
          : [];

        const selected = roleCodes.map(code =>
          new Map((all || []).map(r => [r.code, r])).get(code) || { code, name: code }
        );

        const sortedSelected = sortRolesByName(selected);
        setSelectedRoles(sortedSelected);
        const selectedSet = new Set(sortedSelected.map(r => r.code));
        setAvailableRoles(sortRolesByName(all.filter(r => !selectedSet.has(r.code))));
        setSelectedAvailableRows([]);
        setSelectedSelectedRows([]);
      })
      .catch(() => {})
      .finally(() => {
        if (mounted) setInitLoading(false);
      });
    return () => { mounted = false; };
  }, []);

  useEffect(() => {
    if ((!window.App.urlVars().create && window.App.urlVars().roleId) || (entity === 'roles' && id)) {
      setLoading(true);
      apiCall('get', '/api/v2/role-group/' + (window.App.urlVars().roleId ?? id))
        .then(response => {
          setFormData(response.data.data)
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }
  }, [])

  return (
  <div className={"roles-dnd widget"}>
    {loading &&
      <ProgressBar
        mode="indeterminate"
        style={{height: '5px', position: "absolute", top: 0, left: 0, borderRadius: 0}}
      />
    }

    <Form
      onSubmit={onSubmit}
      initialValues={formData}
      validate={validate}
      render={({handleSubmit}) => (
        <form onSubmit={handleSubmit}>
          <div className={"p-grid"}>
            <div className={"p-col-12"}>
              <Field name="name" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="name" className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldName')}</label>
                  <InputText
                    id="name"
                    {...input}
                    value={formData.name}
                    onChange={(e) => setFormData(prev => ({...prev, name: e.target.value}))}
                    className={classNames({'p-invalid': isFormFieldValid(meta)})}
                  />
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>

            <div
              className={"p-col-12 p-lg-6"}
              onDragOver={handleDragOver}
              onDrop={(e) => handleDrop(e, "available")}
            >
              <Panel>
                <div className={"p-grid"}>
                  <div className={"p-col-12 p-text-left"}>
                    <h3 className={"p-m-0 p-p-0 text-primary"}>
                      {t('availableRoles')}
                    </h3>
                  </div>
                  <div className={"p-col-12 p-text-left"}>
                    <InputText
                      value={availableRoleSearch}
                      onChange={(e) => setAvailableRoleSearch(e.target.value)}
                      placeholder={t('dsSearch')}
                      className="p-inputtext-sm"
                      style={{ width: '180px' }}
                    />
                  </div>
                </div>

                <DataTable
                  emptyMessage={t('noResults')}
                  loading={initLoading}
                  size={"small"}
                  value={filterRoles(availableRoles, availableRoleSearch)}
                  autoLayout
                  filterDisplay="none"
                  responsiveLayout="scroll"
                  stripedRows
                  ref={dtLeft}
                  dataKey="code"
                  selection={selectedAvailableRows}
                  onSelectionChange={e => setSelectedAvailableRows(e.value)}
                >
                  <Column selectionMode="multiple" headerStyle={{width: '3rem'}}/>
                  <Column
                    header={t('columnPermission')}
                    body={(rowData) => (
                      <div
                        draggable
                        style={{cursor: 'move'}}
                        onDragStart={(e) => handleDragStart(e, rowData, 'available')}
                      >
                        {rowData?.name}
                      </div>
                    )}
                  />
                </DataTable>
              </Panel>
            </div>

            <div
              className={"p-col-12 p-lg-6"}
              onDragOver={handleDragOver}
              onDrop={(e) => handleDrop(e, "selected")}
            >
              <Panel>
                <div className={"p-grid"}>
                  <div className={"p-col-12 p-text-left"}>
                    <h3 className={"p-m-0 p-p-0 text-primary"}>
                      {t('selectedRoles')}
                    </h3>
                  </div>
                  <div className={"p-col-12 p-text-left"}>
                    <InputText
                      value={selectedRoleSearch}
                      onChange={(e) => setSelectedRoleSearch(e.target.value)}
                      placeholder={t('dsSearch')}
                      className="p-inputtext-sm"
                      style={{ width: '180px' }}
                    />
                  </div>
                </div>

                <DataTable
                  emptyMessage={t('noSelectedPermission')}
                  size={"small"}
                  loading={initLoading}
                  value={filterRoles(selectedRoles, selectedRoleSearch)}
                  autoLayout
                  filterDisplay="none"
                  responsiveLayout="scroll"
                  stripedRows
                  ref={dtRight}
                  dataKey="code"
                  selection={selectedSelectedRows}
                  onSelectionChange={e => setSelectedSelectedRows(e.value)}
                >
                  <Column selectionMode="multiple" headerStyle={{width: '3rem'}}/>
                  <Column
                    header={t('columnPermission')}
                    body={(rowData) => (
                      <div
                        draggable
                        style={{cursor: 'move'}}
                        onDragStart={(e) => handleDragStart(e, rowData, 'selected')}
                      >
                        {rowData?.name }
                      </div>
                    )}
                  />
                </DataTable>
              </Panel>
            </div>
          </div>

          <div className={"p-grid p-mt-1"}>
            <div className={"p-col-12 p-text-right p-col-align-center"}>
              <Button
                type="submit"
                label={t('save')}
                loading={loading}
                icon={"pi pi-save"}
                className="p-button-success p-ml-2"
              />
              <Button
                type="submit"
                label={t('saveAndBack')}
                onClick={() => { props = {...props, goback: true}; }}
                loading={loading}
                icon={"pi pi-arrow-left"}
                className="p-button-success p-ml-2"
              />
            </div>
          </div>
        </form>
      )}
    />
  </div>
);

}
export default withTranslation('common')(RolesFormComponent);
